export default __webpack_public_path__ + "static/media/circleShapeSecondary2Color.d5465deb.svg";